import React, { useRef, useState } from 'react';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { closeModal, setModal } from '../../../../../Features/inventoryManagementSlice';

function ProductVariants() {
    const dispatch = useDispatch();

    const containerRef = useRef(null);

    useOutsideClickHandler(containerRef, () => {
        dispatch(closeModal());
    });

    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleCloseModal = () => {
        dispatch(closeModal());
    }

    const handleNext = () => {
        if(selectedOption.trim()) {
            dispatch(setModal(`${selectedOption}-variant-form`));
        }
    }

    return (
        <div ref={containerRef} className='w-[44%] h-fit p-6 pt-[18px] flex flex-col gap-6 rounded-xl bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]'>
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                    <div className="flex items-center justify-between">
                        <p className='font-semibold text-2xl text-[#121212] select-none'>Product Variants</p>

                        <button onClick={handleCloseModal} className="outline-none w-11 h-11 flex items-center justify-center">
                            <img className='select-none' src={Cross} alt="" />
                        </button>
                    </div>

                    <p className='font-medium text-[16px] leading-7 text-[#666666] select-none'>You have the option to include all the variants for this product.</p>
                </div>

                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-1">
                        <label htmlFor='size-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedOption === 'size' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                {
                                    selectedOption === 'size' && 
                                    <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                                }
                            </div>
                        </label>

                        <label htmlFor="size-radio" className='font-semibold text-base text-[#121212] cursor-pointer select-none'>
                            <input 
                                id='size-radio'
                                value='size' 
                                type="radio" 
                                checked={selectedOption === 'size'} 
                                onChange={handleOptionChange} 
                                className='hidden' 
                            />
                            Size
                        </label>
                    </div>

                    <div className="flex items-center gap-1">
                        <label htmlFor='color-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedOption === 'color' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                {
                                    selectedOption === 'color' && 
                                    <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                                }
                            </div>
                        </label>

                        <label htmlFor="color-radio" className='font-semibold text-base text-[#121212] cursor-pointer select-none'>
                            <input 
                                id='color-radio'
                                value='color' 
                                type="radio" 
                                checked={selectedOption === 'color'} 
                                onChange={handleOptionChange} 
                                className='hidden' 
                            />
                            Color
                        </label>
                    </div>

                    {/* <div className="flex items-center gap-1">
                        <label htmlFor='others-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedOption === 'others' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                {
                                    selectedOption === 'others' && 
                                    <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                                }
                            </div>
                        </label>

                        <label htmlFor="others-radio" className='font-semibold text-base text-[#121212] cursor-pointer select-none'>
                            <input 
                                id='others-radio'
                                value='others' 
                                type="radio" 
                                checked={selectedOption === 'others'} 
                                onChange={handleOptionChange} 
                                className='hidden' 
                            />
                            Others
                        </label>
                    </div> */}
                </div>
            </div>

            <button 
                onClick={handleNext} 
                className={`${selectedOption === '' ? 'bg-buttonDisabledBg cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryAccent cursor-pointer'} text-buttonText px-4 py-2 rounded font-semibold text-base`}
            >Next</button>
        </div>
    );
}

export default ProductVariants;
